<div class="company-actions">
  <ng-container *ngIf="listType === 'mixed'; else definedList">
    <ng-container *ngIf="isWishedCompany(company.id); else notWishedIcon">
      <div class="wished active" (click)="updateWishStatus($event, company, 'clearWish')"></div>
    </ng-container>

    <ng-template #notWishedIcon>
      <span class="icon-i-heart-border" (click)="updateWishStatus($event, company, 'addWish')"></span>
    </ng-template>

    <ng-container *ngIf="showExcludedAction">
      <ng-container *ngIf="isBlockedCompany(company.id); else notBlockedIcon">
        <div class="exclude active" (click)="updateBlockedStatus($event, company, 'clearBlocked')"></div>
      </ng-container>

      <ng-template #notBlockedIcon>
        <div class="exclude" (click)="updateBlockedStatus($event, company, 'addBlocked')"></div>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #definedList>
    <div
      class="wished"
      [class.active]="listType === 'wishlist'"
      (click)="updateWishStatus($event, company, listType === 'wishlist' ? 'clearWish' : 'addWish')"
    ></div>
    <ng-container *ngIf="showExcludedAction">
      <div
        class="exclude"
        [class.active]="listType === 'blocked'"
        (click)="updateBlockedStatus($event, company, listType === 'blocked' ? 'clearBlocked' : 'addBlocked')"
      ></div>
    </ng-container>
  </ng-template>
  <div class="arrow-action" *ngIf="location !== 'companyDetail'" [ngClass]="{ open: selectedCompanyID === company.id }"></div>
</div>
